module.exports = __webpack_public_path__ + "media/images/lp/industries/bg_circle-0769309d7a53373d6cd4ad4a5310071e.svg";